import React, { useState } from "react";
import "./LastMinuteOffers.css";

const offers = [
  {
    title: "Royal Rajasthan",
    price: "₹12,500",
    image: "/assets/rajasthan.jpg",
    details:
      "Explore the royal palaces, forts, and deserts of Rajasthan. Experience camel rides, traditional folk dances, and colorful bazaars.",
  },
  {
    title: "Goa Beaches",
    price: "₹8,900",
    image: "/assets/goa.jpg",
    details:
      "Relax on the sandy beaches of Goa, enjoy water sports, vibrant nightlife, and authentic Goan seafood delicacies.",
  },
  {
    title: "Kashmir Paradise",
    price: "₹15,000",
    image: "/assets/kashmir.jpg",
    details:
      "Discover the breathtaking valleys of Kashmir, ride a shikara on Dal Lake, and trek through snow-capped mountains.",
  },
  {
    title: "Spiritual Varanasi",
    price: "₹7,200",
    image: "/assets/banaras.jpg",
    details:
      "Witness the sacred Ganga Aarti, explore ancient temples, and experience the spiritual essence of India's oldest city.",
  },
  {
    title: "Backwaters Kerala",
    price: "₹10,500",
    image: "/assets/kerela.jpg",
    details:
      "Sail through serene backwaters on a houseboat, explore lush greenery, and enjoy authentic Kerala cuisine.",
  },
  {
    title: "Ladakh Adventure",
    price: "₹18,000",
    image: "/assets/ladakh.jpg",
    details:
      "Embark on a thrilling adventure across Ladakh’s mountains, visit Pangong Lake, monasteries, and scenic high-altitude passes.",
  },
];

const chooseTours = [
  { title: "Self-Guided", icon: "/assets/icon1.png" },
//   { title: "Self-Guided", icon: "/assets/icon1.jpg" },
  { title: "Cruises", icon: "/assets/icon2.png" },
  { title: "Adventure", icon: "/assets/icon3.png" },
  { title: "Wildlife", icon: "/assets/icon4.png" },
  { title: "Seaside", icon: "/assets/icon5.png" },
];

const LastMinuteOffers = () => {
  const [selectedOffer, setSelectedOffer] = useState(null);

  return (
    <>
      {/* ==== LAST MINUTE OFFERS ==== */}
      <section className="offers-section">
        <h2 className="offers-title">Last Minute Offers</h2>
        <p className="offers-subtitle">
          Book a memorable Indian tour at great prices! Grab our last minute
          offer and pack your bags for the journey you dream about.
        </p>

        <div className="offers-grid">
          {offers.map((offer, index) => (
            <div
              key={index}
              className="offer-card"
              onClick={() => setSelectedOffer(offer)}
            >
              <img
                src={offer.image}
                alt={offer.title}
                className="offer-image"
              />
              <div className="offer-overlay">
                <h3>{offer.title}</h3>
                <p>{offer.price}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Details Popup */}
        {selectedOffer && (
          <div className="offer-details">
            <button
              className="close-btn"
              onClick={() => setSelectedOffer(null)}
            >
              ✕
            </button>
            <img
              src={selectedOffer.image}
              alt={selectedOffer.title}
              className="details-image"
            />
            <div className="details-content">
              <h3>{selectedOffer.title}</h3>
              <p className="details-price">{selectedOffer.price}</p>
              <p className="details-text">{selectedOffer.details}</p>
            </div>
          </div>
        )}
      </section>

      {/* ==== CHOOSE TOUR SECTION ==== */}
      <section className="choose-tour">
        {/* Background image as actual <img> */}
        <img src="/assets/leaves.jpg" alt="Background" className="choose-bg" />

        <div className="choose-overlay">
          <h2 className="choose-title">Choose Tour</h2>
          <p className="choose-subtitle">
            Find your next travel adventure and make it memorable. Explore
            wildlife, enjoy seaside or book a cruise tour. Check out our popular
            destinations.
          </p>

          <div className="choose-grid">
            {chooseTours.map((tour, index) => (
              <div key={index} className="choose-card">
                <img src={tour.icon} alt={tour.title} className="choose-icon" />
                <p>{tour.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default LastMinuteOffers;
